module.exports = __webpack_public_path__ + "img/body-2.55b00288.png";